import React from 'react';
import InventoryConfigList from '../../project/inventory-config/List';

/**
 * 员工/管理员后台的项目库存配置列表页
 * 
 * 按照"统一组件+角色控制"开发规范：
 * - 直接复用主组件 InventoryConfigList
 * - 通过 useAuth 自动判断用户角色权限
 * - 保持与客户后台完全相同的样式和布局
 * - 权限差异化通过主组件内部的角色判断实现
 */
const AdminStaffInventoryConfigList: React.FC = () => {
  // 直接复用主组件，通过 useAuth 自动判断角色权限
  // 主组件内部会根据用户角色动态显示不同的功能和内容
  return <InventoryConfigList />;
};

export default AdminStaffInventoryConfigList;
